import _ from 'lodash'
export const findFlatRef = (flattenedTree, sourceId, book_uuid) => {
  // accumulate an object with the uuids of:
  // literary group: "aaiType": "lit-group-item"
  // books: "aaiType": "is_lit_group"
  // book item: "aaiType": "book-item"
  // character list: "aaiType": "character-list"
  // character: "aaiType": "character-item"

  let detailsSelected = {
    litGroupItem: {},
    isLitGroup: {},
    bookItem: {},
    characterList: {},
    characterItem: {},
    characterVariation: {}
  }

  // start at sourceId (clicked element)
  // traverse BACKWARD in array using curItem's parent (index into array)
  // until aaiType === 'lit-group-item'
  //
  // use aaiType of curItem to selected element of detailsSelected as clone of curItem
  let curIdx = sourceId;
  let isFound = true;
  while (isFound) {
    let curItem = flattenedTree[curIdx];

    switch (curItem.aaiType) {
      case "lit-group-item":
        detailsSelected.litGroupItem = curItem;
        break;
      case "is_lit_group": // book list
        detailsSelected.isLitGroup = curItem;
        break;
      case "book-item": // book list
        detailsSelected.bookItem = curItem;
        break;
      case "character-list": // book list
        detailsSelected.characterList = curItem;
        break;
      case "character-item": // book list
        if (book_uuid !== undefined && curItem.book_uuid === book_uuid) {
          detailsSelected.characterItem = curItem;
        }
        else {
          detailsSelected.characterItem = curItem;
        }
        break;
      default:
        isFound = false;
        break;
    }
    if (isFound) {
      curIdx = curItem.parent;
    }
  }
  return detailsSelected;
}

export const findFlatRefByAaiType = (flattenedTree, valueSet) => {
  // accumulate an object with the uuids of:
  // literary group: "aaiType": "lit-group-item"
  // books: "aaiType": "is_lit_group"
  // book item: "aaiType": "book-item"
  // character list: "aaiType": "character-list"
  // character: "aaiType": "character-item"
  let litGroupIndexes = []
  let detailsSelected = {
    litGroupItem: {},
    isLitGroup: {},
    bookItem: {},
    characterList: {},
    characterItem: {},
    characterVariation: {}
  }

  let isFound = true;

  _.forEach(flattenedTree, (curItem, internalCount) => {
    switch (curItem.aaiType) {
      case "lit-group-item":
        if (curItem.uuid === valueSet.literaryGroup) {

          detailsSelected.litGroupItem = curItem;
          litGroupIndexes.push(internalCount)
        }
        break;
      case "is_lit_group": // book list
        if (curItem.uuid === valueSet.literaryGroup) {
          detailsSelected.isLitGroup = curItem;
          litGroupIndexes.push(internalCount)

        }
        break;
      case "book-item": // book list
        if (curItem.uuid === valueSet.litGroupBook) {
          detailsSelected.bookItem = curItem;
          litGroupIndexes.push(internalCount)

        }
        break;
      case "character-list": // book list

        // detailsSelected.characterList = curItem;

        break;
      case "character-item": // book list
        if (valueSet.litGroupBook !== undefined && curItem.book_uuid === valueSet.litGroupBook) {
          if (curItem.uuid === valueSet.bookCharacter) {
            detailsSelected.characterItem = curItem;
            litGroupIndexes.push(internalCount)
          }
        }
        break;
      case "character-variation":
        break;
      default:
        isFound = false;
        break;
    }
  })

  console.log('findFlatRefByAaiType litGroupIndexes', litGroupIndexes)
  return { detailsSelected, litGroupIndexes: litGroupIndexes };


}


export const aaiflattenTree = function (tree, litGroupIndexes) {
  let internalCount = 0;
  const flattenedTree = [];

  const flattenTreeHelper = function (tree, parent, litGroup, litGroupIndexes) {
    let litGrp = litGroup;
    const node = {
      id: tree.id || internalCount,
      name: tree.name,
      children: [],
      parent,
      aaiType: tree.aaiType,  // include custom attribute
      uuid: tree.uuid,
      litGroup: litGrp,
      book_uuid: tree?.book_uuid || ""
    };

    if (tree.aaiType === "lit-group-item") {
      if (!litGroupIndexes.current.includes(internalCount)) {
        litGroupIndexes.current.push(internalCount)
      }
      litGrp = tree.uuid;
      node.litGroup = litGrp
    }
    else if (litGroupIndexes && (litGroupIndexes.current.length === 0 || !litGroupIndexes.current.includes(internalCount))) {
      litGroupIndexes.current.push(internalCount);
    }

    // if (flattenedTree.find((x) => x.id === node.id)) {
    //   console.error(`Multiple TreeView nodes have the same ID (${node.id}). IDs must be unique.`);

    //   // // Example recovery strategy: Assign a new unique ID (simplified approach)
    //   // // In a real application, ensure this ID is truly unique in the context
    //   // node.id = `conflict-resolved-${node.id}-${Date.now()}`;

    //   // // Optionally notify the user (simplified example)
    //   // // This could be a modal, toast, or inline notification, depending on your UI library/framework
    //   // alert("A minor issue occurred but has been resolved. If you encounter any odd behavior, please refresh the page.");
    // }

    flattenedTree.push(node);
    internalCount += 1; // keep track of index count for all children, of all types
    if (!tree.children || !tree.children.length) return;
    for (const child of tree.children) {
      flattenTreeHelper(child, node.id, litGrp, litGroupIndexes);
    }
    for (const child of flattenedTree) {
      if (child.parent === node.id) {
        node.children.push(child.id);
      }
    }
  };
  flattenTreeHelper(tree, null, null, litGroupIndexes);
  return flattenedTree;
};

